module.exports = __webpack_public_path__ + "static/img/daiyunying_03.307c3fb5.jpg";